import { RegistrationEmail } from 'components/registration/registration-email';
import React from 'react';

export const RegistrationPage: React.FC = () => {
    return <RegistrationEmail />;
};
